/**
 * 商品ページ：選択中バリアントの納期表示と properties[納期] 隠し input 更新
 * 依存: Splice <variant-picker> が発火する on:variant:change イベント
 */
(function () {
	if (window.customElements && customElements.get("custom-variant-lead-time"))
		return;

	function computeLeadText(dateStr) {
		if (!dateStr) return null;
		var parts = String(dateStr).split("-");
		if (parts.length !== 3) return null;
		var month = parseInt(parts[1], 10);
		var day = parseInt(parts[2], 10);
		if (isNaN(month) || isNaN(day)) return null;
		var bucket;
		if (day <= 10) bucket = "上旬";
		else if (day <= 20) bucket = "中旬";
		else bucket = "下旬";
		return month + "月" + bucket + "以降発送";
	}

	class CustomVariantLeadTime extends HTMLElement {
		constructor() {
			super();
			this.leadTimes = {};
			this.onVariantChange = this.onVariantChange.bind(this);
		}

		connectedCallback() {
			try {
				this.leadTimes = JSON.parse(this.dataset.leadTimes || "{}");
			} catch (err) {
				console.error("[delivery-date] failed to parse lead times JSON", err);
				this.leadTimes = {};
			}

			this.display = this.querySelector("[data-lead-time-display]");
			this.textEl = this.querySelector("[data-lead-time-text]");
			this.input = this.querySelector("[data-lead-time-property]");
			this.productId = parseInt(this.dataset.productId || "", 10) || null;

			// セクションとして配置される想定 (.js-product の外側) のため、
			// document 上で on:variant:change を受け、product_id でフィルタする
			var initialVariantId = this.dataset.initialVariantId;

			// 同じ .js-product 配下の product-form を form 属性で input に紐付ける
			// (input がフォーム外にあると /cart/add に properties[納期] が含まれない)
			// 注:
			//  - quick-add-drawer も .js-product クラスを持つので、商品ページと quick-buy 両対応
			//  - Shop Pay の instalments-form 等にも同 value の input[name="id"] が存在するため、
			//    form.js-product-form 配下のみを対象にする
			//  - <input name="id"> による named element 衝突を回避するため getAttribute/setAttribute を使う
			var scopeEl = this.closest(".js-product") || document;
			if (this.input) {
				var productForm = scopeEl.querySelector("form.js-product-form");
				if (productForm) {
					var formId = productForm.getAttribute("id");
					if (!formId) {
						formId =
							"product-form-auto-" + Math.random().toString(36).slice(2, 8);
						productForm.setAttribute("id", formId);
					}
					this.input.setAttribute("form", formId);
				}
			}

			this.update(initialVariantId ? initialVariantId : null);

			document.addEventListener("on:variant:change", this.onVariantChange);
		}

		disconnectedCallback() {
			document.removeEventListener("on:variant:change", this.onVariantChange);
		}

		onVariantChange(event) {
			var detail = event && event.detail;
			if (!detail || !detail.variant) return;
			// 別商品 (quick-buy 等) の variant 変更は無視
			if (
				this.productId &&
				detail.variant.product_id &&
				detail.variant.product_id !== this.productId
			) {
				return;
			}
			this.update(detail.variant.id != null ? detail.variant.id : null);
		}

		update(variantId) {
			var dateStr = variantId != null ? this.leadTimes[variantId] : null;
			var leadText = computeLeadText(dateStr);

			if (leadText) {
				if (this.textEl) this.textEl.textContent = leadText;
				if (this.display) this.display.hidden = false;
				this.hidden = false;
				if (this.input) {
					this.input.value = leadText;
					this.input.disabled = false;
				}
			} else {
				if (this.display) this.display.hidden = true;
				this.hidden = true;
				if (this.input) {
					this.input.value = "";
					this.input.disabled = true;
				}
			}
		}
	}

	customElements.define("custom-variant-lead-time", CustomVariantLeadTime);
})();
